// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3tole","boxTitle":"Qualiphy_boxTitle__2muIP","box":"Qualiphy_box__eyFaF","toggleWrap":"Qualiphy_toggleWrap__2K0j7"};